import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Food.css";

import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";
import FoodTitulos from "./foodparts/foodTitulos/FoodTitulos";
import FoodProductsSection from "./foodparts/foodProducts/FoodProductsSection";
import FoodBanners from "./foodparts/foodBanners/FoodBanners";
import FoodNavigate from "./foodparts/foodNavigate/FoodNavigate";
import IntroParceiros from "../intro/parts/IntroParceiros/IntroParceiros";
import IntroTitulos from "../intro/parts/IntroTitulos/IntroTitulos";
import Section from "../../components/debug/Section";

export default function Food() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const [titulos, setTitulos] = useState([]);
  const [loadingTitulos, setLoadingTitulos] = useState(true);

  // 🔹 Marcas
  const [marcas, setMarcas] = useState([]);
  const [loadingMarcas, setLoadingMarcas] = useState(true);

  // 🔹 Banners
  const [banners, setBanners] = useState([]);
  const [loadingBanners, setLoadingBanners] = useState(true);

  // 🔹 Carregar banners

  useEffect(() => {
    async function carregarBanners() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/home_media/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setBanners(data);
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
      } finally {
        setLoadingBanners(false);
      }
    }

    carregarBanners();
  }, []);

  // 🔹 Carregar Marcas
  useEffect(() => {
    async function carregarMarcas() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/marcas/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setMarcas(data);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
      } finally {
        setLoadingMarcas(false);
      }
    }

    carregarMarcas();
  }, []);

  //Carregar Titulos
  useEffect(() => {
    async function carregarTitulos() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/titulos/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );

        const data = await response.json();
        setTitulos(data);
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
      } finally {
        setLoadingTitulos(false);
      }
    }

    carregarTitulos();
  }, []);

  function getFoodTitulo(localizacao) {
    const titulo = titulos.find((item) => item.localizacao === localizacao);

    return titulo?.descricao || null;
  }

  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <Section name="FoodBanners 1">
        <FoodBanners //Banner1
          banners={banners}
          ordem={1}
        />
      </Section>

      <Section name="FoodNavigate ">
        <FoodNavigate //navegar categorias
        />
      </Section>

      <Section name="FoodBanners 2">
        <FoodBanners //Banner2
          banners={banners}
          ordem={2}
        />
      </Section>
      {/* CONTEÚDO */}
      <div className="food-wrapper">
        <Section name="FoodTitulo 1">
          {getFoodTitulo("foodtitulo01") && (
            <FoodTitulos title={getFoodTitulo("foodtitulo01")} />
          )}
        </Section>

        <Section name="FoodProductsSectio 1">
          <FoodProductsSection localizacao="food01" />
        </Section>
      </div>

      <div className="food-wrapper">
        <Section name="FoodTitulo 2">
          {getFoodTitulo("foodtitulo02") && (
            <FoodTitulos title={getFoodTitulo("foodtitulo02")} />
          )}
        </Section>

        <Section name="FoodProductsSectio 2">
          <FoodProductsSection localizacao="food02" />
        </Section>
      </div>

      <Section name="IntroTitulo ">
        <IntroTitulos
          titulos={titulos}
          loading={loadingTitulos}
          localizacao="introtitulo"
          ordem={3}
        />
      </Section>

      <Section name="FoodParceiros">
        <IntroParceiros
          marcas={marcas}
          loading={loadingMarcas}
          localizacao="introparceiros01"
        />
      </Section>

      <div className="food-wrapper">
        <Section name="FoodTitulo 3">
          {getFoodTitulo("foodtitulo03") && (
            <FoodTitulos title={getFoodTitulo("foodtitulo03")} />
          )}
        </Section>

        {/* PRODUTOS */}
        <Section name="FoodProductsSectio 3">
          <FoodProductsSection localizacao="food03" />
        </Section>
      </div>

      <div className="food-wrapper">
        <Section name="FoodTitulo 4">
          {getFoodTitulo("foodtitulo04") && (
            <FoodTitulos title={getFoodTitulo("foodtitulo04")} />
          )}
        </Section>

        <Section name="FoodProductsSectio 4">
          <FoodProductsSection localizacao="food04" />
        </Section>
      </div>

      <Section name="FoodBanner 3">
        <FoodBanners //Banner3
          banners={banners}
          ordem={3}
        />
      </Section>

      <div className="food-wrapper">
        <Section name="FoodTitulo 5">
          {getFoodTitulo("foodtitulo05") && (
            <FoodTitulos title={getFoodTitulo("foodtitulo05")} />
          )}
        </Section>

        <Section name="FoodProductsSectio 5">
          <FoodProductsSection localizacao="food05" />
        </Section>
      </div>

      <div className="food-wrapper">
        <Section name="FoodTitulo 6">
          {getFoodTitulo("foodtitulo06") && (
            <FoodTitulos title={getFoodTitulo("foodtitulo06")} />
          )}
        </Section>

        <Section name="FoodProductsSectio 6">
          <FoodProductsSection localizacao="food06" />
        </Section>
      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}
